<template>
    <div class="main-wrapper">
        <div class="preloader">
            <div class="lds-ripple">
                <div class="lds-pos"></div>
                <div class="lds-pos"></div>
            </div>
        </div>
        <router-view></router-view>
    </div>
</template>

<script>
    export default {
        name: "AuthLayout",
        data() {
            return {
                version: ""
            }
        },
        methods: {
            release() {
                this.$http.get('/')
                .then(reply => {
                    this.version = reply.data.version;
                })
                .catch(err => console.log(err))
            }
        }
    }
</script>

<style scoped>

</style>